/*
 * Evey attendee popup: prefill from data already saved in the cart (TS-4874 workaround, TESTED ONLY VIA CONSOLE)
 *
 * Problem: the Evey popup always renders blank forms and ignores `_evey:attendee:*` line item properties
 * already saved in the cart (after refresh, after returning from checkout, or when a new event is added).
 *
 * What it does: when the popup becomes visible, read /cart.js and fill each form that already has complete
 * data. Evey still validates everything itself (counter + submit button), so nothing is bypassed.
 * Fails safe: if a selector or title does not match, the form stays blank (= current behavior).
 *
 * Known limits (see project doc):
 *  - Only +45 phones are prefilled. Other country codes are left blank on purpose: injecting a foreign
 *    number into the DK-flag field made Evey store a doubled prefix (+4646701234567).
 *  - Matching is by product title + order of units in the cart. Not tested with 3+ identical-title lines
 *    interleaved with other events, nor with the "use same info" option enabled.
 *  - Depends on Evey DOM: .evey-attendee-info, .evey-modal, .evey-attendee-info-content,
 *    input[name$="firstname]"], [data-completed-tickets-count].
 */
(function () {
  var FIELDS = ['firstname', 'lastname', 'alder', 'postnummer', 'phone', 'email'];

  function setValue(el, value) {
    var proto = el.tagName === 'SELECT' ? HTMLSelectElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, value);
    ['input', 'change', 'blur'].forEach(function (t) {
      el.dispatchEvent(new Event(t, { bubbles: true }));
    });
  }

  function visibleRoot() {
    return Array.prototype.find.call(document.querySelectorAll('.evey-attendee-info'), function (r) {
      return r.querySelector('.evey-modal:not(.visually-hidden)');
    });
  }

  async function prefill() {
    var root = visibleRoot();
    if (!root) {
      // popup closed: allow prefill again next time it opens (same page load)
      Array.prototype.forEach.call(document.querySelectorAll('.evey-attendee-info'), function (r) { delete r.dataset.prefilled; });
      return;
    }
    if (root.dataset.prefilled === '1') return;
    root.dataset.prefilled = '1';

    var cart = await fetch('/cart.js').then(function (r) { return r.json(); });

    // units per product title, in cart order; null = still pending
    var unitsByTitle = {};
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      var blocks = Array.from(new Set(
        Object.keys(props)
          .filter(function (k) { return k.indexOf('_evey:attendee:') === 0; })
          .map(function (k) { return k.split(':').slice(2, 4).join(':'); })
      )).sort();
      for (var q = 0; q < item.quantity; q++) {
        var b = blocks[q];
        var data = null;
        if (b) {
          data = {};
          FIELDS.forEach(function (f) { data[f] = props['_evey:attendee:' + b + ':' + f]; });
          var complete = FIELDS.every(function (f) { return String(data[f] == null ? '' : data[f]).trim() !== ''; });
          if (!complete) data = null;
        }
        (unitsByTitle[item.product_title] = unitsByTitle[item.product_title] || []).push(data);
      }
    });

    var content = root.querySelector('.evey-attendee-info-content');
    if (!content) return;
    var walker = document.createTreeWalker(content, NodeFilter.SHOW_ELEMENT);
    var title = null;
    var used = {};
    var node;
    while ((node = walker.nextNode())) {
      if (node.children.length === 0 && /^\d+\. \S+ 2026: /.test((node.textContent || '').trim())) {
        title = node.textContent.trim();
        continue;
      }
      if (!node.matches || !node.matches('input[name$="firstname]"]')) continue;

      var box = node;
      while (box.parentElement && box.parentElement !== content &&
             box.parentElement.querySelectorAll('input[name$="firstname]"]').length === 1) {
        box = box.parentElement;
      }
      used[title] = (used[title] == null ? -1 : used[title]) + 1;
      var data = (unitsByTitle[title] || [])[used[title]];
      if (!data) continue;

      FIELDS.forEach(function (f) {
        var el = box.querySelector('[name$=":' + f + ']"]');
        if (!el) return;
        if (f === 'phone') {
          if (String(data.phone).indexOf('+45') !== 0) return; // leave non-DK blank (see limits)
          setValue(el, String(data.phone).replace(/^\+45/, ''));
        } else {
          setValue(el, data[f]);
        }
      });
    }
  }

  new MutationObserver(prefill).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();